import { Input } from "antd";
import { useState, useEffect, useRef } from "react";

const { Search } = Input;

const SearchInput = ({ onSearch, onKeyPress, value, debounceDelay = 500 }) => {
  const [localValue, setLocalValue] = useState(value || '');
  const debounceTimeoutRef = useRef(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  useEffect(() => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      if (isMountedRef.current && localValue !== value) {
        onSearch({ target: { value: localValue } });
      }
    }, debounceDelay);

    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, [localValue, debounceDelay]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    // Immediate update for UI
    if (newValue === '') {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
      onSearch({ target: { value: '' } });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onKeyPress) {
      onKeyPress(e);
    }
  };

  return (
    <Search
      className="search-icon-right"
      placeholder="Search by name, phone number, or keywords"
      allowClear
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      value={localValue}
    />
  );
};

export default SearchInput;